import { ILocalStorageScope } from "../interfaces/localstorageScope";

const isSupported = typeof Storage !== "undefined";

const keys = {
    newComment: (topicId: string, personId: string) => `topics/${topicId}/people/${personId}/comments/new`,
    newReply: (topicId: string, personId: string, commentId: string) => `topics/${topicId}/people/${personId}/comments/${commentId}/replies/new`
}

class WCCLocalStorageManagerScope implements ILocalStorageScope {
    constructor(public key: string) { }

    get() {
        if (isSupported)
            return localStorage.getItem(this.key) ?? undefined;
    }

    set(value: string) {
        if (isSupported)
            localStorage.setItem(this.key, value);
    }

    remove() {
        if (isSupported)
            localStorage.removeItem(this.key);
    }
}

export class WCCLocalStorageManager {
    keys = keys

    taskDescriptionShown = new WCCLocalStorageManagerScope('task/Content/shown');
    taskSecondaryDescriptionShown = new WCCLocalStorageManagerScope('task/secondarycontent/shown');

    pixabayQuery = new WCCLocalStorageManagerScope('pixabay/query');
    unsplashQuery = new WCCLocalStorageManagerScope('unsplash/query');

    newComment = (topicId: string, personId: string) => new WCCLocalStorageManagerScope(`topics/${topicId}/people/${personId}/comments/new`);
    newReply = (topicId: string, personId: string, commentId: string) => new WCCLocalStorageManagerScope(`topics/${topicId}/people/${personId}/comments/${commentId}/replies/new`);
    commentsFilters = (discussionId: string, userId: string) => new WCCLocalStorageManagerScope(`discussions/${discussionId}/commentsfilters/${userId}`);

    cameraId = (userId: string) => new WCCLocalStorageManagerScope(`users/${userId}/camera`);
    microphoneId = (userId: string) => new WCCLocalStorageManagerScope(`users/${userId}/microphone`);
    speakersId = (userId: string) => new WCCLocalStorageManagerScope(`users/${userId}/speakers`);

    youtubeVideosMetadata = new WCCLocalStorageManagerScope(`youtube/videos/metadata`);

    isSupported() {
        return isSupported;
    }

    getItem(key: string) {
        if (isSupported)
            return localStorage.getItem(key);

        return null;
    }

    setItem(key: string, value: string) {
        if (isSupported)
            localStorage.setItem(key, value);
    }

    removeItem(key: string) {
        if (isSupported)
            localStorage.removeItem(key);
    }
}

const localStorageManager = new WCCLocalStorageManager();

export default localStorageManager;